(() => {
  document.querySelectorAll('[data-add-form]').forEach(form => {
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[data-form-status]');
      button.disabled = true; button.textContent = 'Wird hinzugefügt …';
      try {
        const response = await fetch('/de-de/cart/add.js', { method: 'POST', body: new FormData(form), headers: {Accept:'application/json'} });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Bitte versuche es erneut.');
        window.location.assign('/de-de/cart');
      } catch (error) {
        status.textContent = 'Das Produkt konnte nicht hinzugefügt werden. Bitte prüfe die Menge und versuche es erneut.';
        button.disabled = false; button.textContent = 'In den Warenkorb';
      }
    });
  });
})();
